import { render } from "./ClientInvoiceList.vue?vue&type=template&id=a561aa12&ts=true"
import script from "./ClientInvoiceList.vue?vue&type=script&lang=ts"
export * from "./ClientInvoiceList.vue?vue&type=script&lang=ts"

import "./ClientInvoiceList.vue?vue&type=style&index=0&id=a561aa12&lang=scss"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__